import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import FormattedCurrency from 'shared/FormattedCurrency';
import AddTickets from 'checkout/views/ticket-picker/components/AddTickets';
import { getSelectedTimeslotBuyout } from '../../../selectors/tickets';
import DetailsToggle from '@s/DetailsToggle'
import ProductConfigurationWrapper from '../../product-picker/containers/ProductConfigurationWrapper';
import ImageGalleryWrapper from '@s/ImageGalleryWrapper';
import { isKioskMode } from 'checkout/selectors/ui';
import { TICKET_FEE_SEPARATE, TICKET_PRICE_ONLY } from '../../../reducers/ui';
import Translation from "../../../../shared/Translation";
import { isMultiEmbed } from '../../../selectors/ui';
import { getMainEvent } from '../../../selectors/event';
import classNames from 'classnames';
import { getXssFilter } from 'checkout/helpers/helpers';

class Bundle extends Component {
    constructor(props) {
        super(props);

        this.state = {
            showDescription: false,
            showProductDescription: false,
        }
    }

    toggleDescription = () => {
        this.setState({showDescription: !this.state.showDescription});
        if (this.state.showDescription === false){
            Object.values(this.props.bundle.contents.products).map((product, i) => {
                if (product.toggle) {
                    product.toggle = false;
                }
            });
        }
    };

    toggleProductDescription = (product) => {
        product.toggle = !product.toggle;
        this.setState({showProductDescription: product.toggle});
    };

    displayGallery = (product) => {
        let imageGallery = <span></span>;
        if (product.images) {
            imageGallery = <span className="image__gallery">
                <ImageGalleryWrapper
                    images={product.images}
                    altTexts={product.images_alt_texts}
                    name={product.name}
                />
            </span>;
        }

        return imageGallery;
    };

    getPriceLevels = () => {
        return Object.values(this.props.bundle.contents.levels).map((priceLevel, i) => {

            let priceLevelDescription = '';

            if (this.props.isPackage) {
                if (priceLevel.event) {
                  priceLevelDescription = <Translation interpolation={{event:priceLevel.event}}>{'checkout__pricelevel_by_event'}</Translation>
                  if (priceLevel.date) {
                    priceLevelDescription = <Translation interpolation={{event:priceLevel.name, date:priceLevel.date}}>{'checkout__pricelevel_by_event_and_date'}</Translation>
                    }
                }
            }

            return (
                <div className="bundle__included-item bundle-price-level" key={priceLevel.id + "_" + i}>
                  <span className="bundle__included-title" key={priceLevel.id}><Translation interpolation={{quantity:priceLevel.quantity, name:priceLevel.name}}>{'checkout__quantity_by_name'}</Translation> {priceLevelDescription}</span>
                </div>
            )
        })
    };

    getProducts = () => {
        return Object.values(this.props.bundle.contents.products).map((product, i) => {
            return (
              <div className="bundle__included-item bundle-product" key={product.id + "_" + i}>
                <span id={`name_bundle-product_${product.product_id}`} className="bundle__included-title" key={product.product_id}>
                  <Translation interpolation={{ quantity: product.quantity, name: product.name }}>
                    {'checkout__quantity_by_name'}
                  </Translation>
                </span>
                {(product.description || product.images) && (
                  <DetailsToggle
                    onClick={this.toggleProductDescription}
                    index={product}
                    aria-expanded={product.toggle}
                    aria-controls={`description_bundle-product_${product.product_id}`}
                    aria-describedby={`name_bundle-product_${product.product_id}`}
                  />
                )}
                {product.toggle && (
                  <div className="bundle-product__more card">
                    {this.displayGallery(product)}
                    <div
                      id={`description_bundle-product_${product.product_id}`}
                      className="ticket-description__content"
                      dangerouslySetInnerHTML={{
                        __html: getXssFilter().process(product.description)
                      }}
                    />
                  </div>
                )}
              </div>
            )
        })
    };

    displayBundleProductConfiguration = () => {
        if (this.props.bundleQuantity > 0) {
            let productConfigLines = [];
            Object.values(this.props.bundle.contents.products).map((product, index) => {
                let total = 0;
                if (!product.single_configuration) {
                    productConfigLines.push(
                      <div
                        key={index}
                        className="ticket__name"
                        id={product.product_id}
                        role='heading'
                        aria-level='3'
                      >
                        {product.name}
                      </div>);
                    for (let i = 0; i < this.props.bundleQuantity; i++) {
                        for(let j = 0; j < product.quantity; j++) {
                            productConfigLines.push(
                                <div className="product__configuration__option" key={'bundle_' + product.product_id + '_' + i + j}>
                                    <ProductConfigurationWrapper
                                        key={i}
                                        product={product}
                                        configKey={total}
                                        productQuantity={+product.quantity}
                                        bundleQuantity={this.props.bundleQuantity}
                                        bundle={this.props.bundle}
                                        reducerKey={this.props.reducerKey}
                                    />
                                </div>
                            );
                            total++;
                        }
                    }
                }
            });

            return (productConfigLines.length > 0 &&
                <div className="product__configurations__wrapper ticket__item">
                    {productConfigLines}
                </div>
            );
        }
    };

    getBundleDetails = () => {
        return (
            <div className="ticket-description__content ticket__item" name="description_{index}">
                <div className={`ticket-description__more bundle__content ${this.props.bundle.description ? 'card-group' : ''}`} >
                    <div className="card">
                        <span className="bundle-includes__text"><Translation>{'checkout__bundle_includes'}</Translation></span>
                        <span className="bundle-includes">
                            {this.getPriceLevels()}
                            {this.getProducts()}
                        </span>
                    </div>
                    {this.props.bundle.description && (
                      <div
                        className="ticket-description__content-desc card"
                        dangerouslySetInnerHTML={{
                          __html: getXssFilter().process(this.props.bundle.description)
                        }}
                      />
                    )}
                </div>

            </div>
        )
    };

    onIncrement = () => {
        this.props.onIncrement(this.props.bundle);
    };

    onDecrement = () => {
        this.props.onDecrement(this.props.bundle.id);
    };

    render() {
        if(this.props.isKioskMode){
            return(
                <Fragment>
                    <div className="ticket">
                        <div className="ticket__information">
                            <div className="ticket__name" role='heading' aria-level='3'>{ this.props.bundle.name }</div>
                            <div className="ticket__pricing-group">
                                <div className="ticket__price"><FormattedCurrency>{ this.props.bundle.price.amount }</FormattedCurrency>+ <FormattedCurrency>{ this.props.bundle.service_fee.price }</FormattedCurrency> <Translation>{'checkout__fee'}</Translation></div>
                            </div>
                            {<DetailsToggle
                              onClick={this.toggleDescription}
                              aria-expanded={this.state.showDescription}
                              aria-controls={`description_bundle_${this.props.bundle.id}`}
                            />}
                        </div>
                        <div className="ticket__action">
                            <AddTickets
                                onIncrement={this.onIncrement}
                                onDecrement={this.onDecrement}
                                quantity={this.props.bundleQuantity}
                                quantities={this.props.quantities}
                                onQuantityInput={this.props.onQuantityChange}
                                initialQuantities={this.props.initialQuantities}
                                />
                        </div>
                    </div>

                        {this.state.showDescription && (
                          <div
                            id={`description_bundle_${this.props.bundle.id}`}
                            className="ticket__description ticket__item"
                          >
                            {this.getBundleDetails()}
                          </div>
                        )}
                    {this.displayBundleProductConfiguration()}
                </Fragment>
            )
        }

        const totalPrice = this.props.bundle.price.amount + this.props.bundle.service_fee.price;

        const showPriceInInfo = this.props.isMultiEmbed;

        return <Fragment>
            <div className="ticket">
                <div className="ticket__information">
                    <div id={`name_bundle_${this.props.bundle.id}`} className="ticket__name" role='heading' aria-level='3'>{ this.props.bundle.name }</div>
                    {this.props.feeDisplayOption === TICKET_FEE_SEPARATE &&
                        <div>
                            <div className={classNames({"hide-on-medium-screen": !showPriceInInfo})}>
                                <div className="ticket__price--total"><FormattedCurrency>{ totalPrice }</FormattedCurrency></div>
                            </div>
                            <div className="ticket__price"><FormattedCurrency>{ this.props.bundle.price.amount }</FormattedCurrency>&nbsp;+ <FormattedCurrency>{ this.props.bundle.service_fee.price }</FormattedCurrency> <Translation>{this.props.feeVerbiage ? 'checkout__fees_label' : 'checkout__service_fee_label'}</Translation></div>
                        </div>
                    }
                    {this.props.feeDisplayOption === TICKET_PRICE_ONLY &&
                        <div className={classNames("ticket__pricing-group", {"hide-on-medium-screen": !showPriceInInfo})}>
                            <div className="ticket__price"><FormattedCurrency>{ this.props.bundle.price.amount }</FormattedCurrency></div>
                        </div>
                    }
                    {<DetailsToggle
                      onClick={this.toggleDescription}
                      aria-expanded={this.state.showDescription}
                      aria-controls={`description_bundle_${this.props.bundle.id}`}
                      aria-describedby={`name_bundle_${this.props.bundle.id}`}
                    />}
                </div>
                <div className="ticket__pricing-group hide-on-small-screen">
                    {this.props.feeDisplayOption === TICKET_FEE_SEPARATE && !showPriceInInfo &&
                        <div className="ticket__price--total"><FormattedCurrency>{ totalPrice }</FormattedCurrency></div>
                    }
                    {this.props.feeDisplayOption === TICKET_PRICE_ONLY && !showPriceInInfo &&
                        <div className="ticket__price--total"><FormattedCurrency>{ this.props.bundle.price.amount }</FormattedCurrency></div>
                    }
                </div>
                <div className="ticket__action">
                    <AddTickets
                        onIncrement={this.onIncrement}
                        onDecrement={this.onDecrement}
                        quantity={this.props.bundleQuantity}
                        quantities={this.props.quantities}
                        onQuantityInput={this.props.onQuantityChange}
                        initialQuantities={this.props.initialQuantities}
                        disabled={!!this.props.selectedTimeslotBuyout}
                    />
                </div>
            </div>
            {this.state.showDescription &&
                <div id={`description_bundle_${this.props.bundle.id}`} className="ticket__description">
                    {this.getBundleDetails()}
                </div>
            }


            {this.displayBundleProductConfiguration()}
        </Fragment>
    }
}

const mapStateToProps = (state, props) => {
    return {
        selectedTimeslotBuyout: getSelectedTimeslotBuyout(state),
        isKioskMode: isKioskMode(state),
        isMultiEmbed: isMultiEmbed(state),
        feeVerbiage: getMainEvent(state)?.event?.fee_verbiage,
    }
}

Bundle.propTypes = {
    bundle: PropTypes.object,
    onIncrement: PropTypes.func.isRequired,
    onDecrement: PropTypes.func.isRequired,
    onQuantityChange: PropTypes.func.isRequired,
    bundleQuantity: PropTypes.number,
    initialQuantities: PropTypes.arrayOf(PropTypes.number),
    quantities: PropTypes.arrayOf(PropTypes.number),
    selectedTimeslotBuyout: PropTypes.object,
};

export default connect(mapStateToProps)(Bundle)
